<template>
  <section>
    <p class="eyebrow">읽기 자료 {{ index + 1 }} / {{ total }}</p>
    <ReadingMaterial :material="material" />
    <p class="notice">전체 자료를 읽은 뒤 아래 버튼을 눌러주세요.</p>
    <button :disabled="busy" @click="$emit('complete')">{{ busy ? '저장 중…' : '읽기 완료 · 문항 시작' }}</button>
  </section>
</template>
<script>
import ReadingMaterial from './ReadingMaterial.vue';
export default {
  components: { ReadingMaterial },
  props: { material: Object, index: Number, total: Number, busy: Boolean },
  emits: ['complete']
};
</script>
